import { render, staticRenderFns } from "./default-layout.vue?vue&type=template&id=20a55904&"
import script from "./default-layout.vue?vue&type=script&lang=js&"
export * from "./default-layout.vue?vue&type=script&lang=js&"
import style0 from "./default-layout.vue?vue&type=style&index=0&id=20a55904&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports